<script>
  import { createEventDispatcher } from 'svelte';

  export let clickable = true
  export let orientation = 'auto' // auto | portrait | landscape
  export let topPadding = false

  const dispatch = createEventDispatcher()

  let clientWidth, clientHeight, finalOrientation

  function onClick(event) {
    dispatch('click', event);
  }

  $: if (orientation === 'auto') {
    finalOrientation = (clientWidth / clientHeight > 2) ? 'landscape' : 'portrait'
  } else {
    finalOrientation = orientation
  }
</script>

<div class="card" bind:clientWidth bind:clientHeight
    class:clickable on:click|stopPropagation={onClick}
    class:portrait={finalOrientation === 'portrait'}
    class:landscape={finalOrientation === 'landscape'}
    class:topPadding
  >
  <slot/>
</div>

<style>
.card {
  --card-content-v-padding: var(--spacer-xl);
  --card-content-h-padding: var(--spacer-lg);

  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  overflow: hidden;

  border: var(--border-width-thick) solid var(--color-black);
  border-radius: var(--border-radius-sm);
  background-color: var(--color-white);
}

.card.topPadding {
  padding-top: var(--card-content-v-padding);
}

.card.clickable {
  cursor: pointer;
}

.card.clickable:hover {
  background-color: var(--color-secondary-light);
  box-shadow: var(--shadow) var(--color-secondary-dark);
}

.card:global(.portrait) {
  flex-direction: column;
  padding-bottom: var(--card-content-v-padding);
  overflow-y: auto;
}

.card:global(.landscape) {
  flex-direction: row;
  padding-bottom: 0;
  align-items: center;
}

</style>
